import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { UserService } from '@http/clients/user.service';
import { DropdownPanelComponent, IconSanitizerService, IDropdownPanel, IDropdownPanelItem } from 'ngx-lib';

@Component({
    selector: 'app-user-apps-panel',
    templateUrl: './user-apps-panel.component.html',
    styleUrls: ['./user-apps-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DropdownPanelComponent]
})
export class UserAppsPanelComponent implements OnInit {
    panel: IDropdownPanel;

    notificationPanelIcon: SafeHtml;

    constructor(
        private readonly userService: UserService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.panel = {
            items: []
        };
        this.notificationPanelIcon = this.iconSanitizer.getIcon('notificationPanel');
    }

    async ngOnInit(): Promise<void> {
        const result = await this.userService.getUserApplications();
        this.panel.items = result.map(
            (item) =>
                ({
                    id: item.name,
                    name: item.name,
                    action: () => window.open(item.url, '_blank')
                }) as IDropdownPanelItem
        );
    }
}
